import Layout from '../../layout';
const homeRouter = {
	path: '/',
	component: Layout,
	redirect: '/',
	name: 'edu',
	meta: {
		title: '1',
		sort: 4,
	},
	children: [
		{
			path: '/',
			component: () => import('@/pages/ideological/views/home/index.vue'),
			name: 'home',
		},
	],
};

export default homeRouter;
